"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _excluded = ["size", "fill"];

var _default = function _default(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? '20' : _ref$size,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? '#24292E' : _ref$fill,
      restProps = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    width: size,
    height: size,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, restProps), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M7.4998 9.58339L9.16646 11.2501L12.9165 7.50006M16.6665 10.0001C16.6665 14.0904 12.2048 17.0654 10.5815 18.0125C10.397 18.1201 10.3047 18.1739 10.1745 18.2018C10.0735 18.2235 9.9261 18.2235 9.82506 18.2018C9.69488 18.1739 9.60263 18.1201 9.41814 18.0125C7.79476 17.0654 3.33313 14.0904 3.33313 10.0001V6.01472C3.33313 5.34846 3.33313 5.01533 3.4421 4.72898C3.53836 4.47601 3.69478 4.25029 3.89785 4.07133C4.12771 3.86875 4.43963 3.75178 5.06347 3.51785L9.53163 1.84228C9.70488 1.77732 9.7915 1.74483 9.88062 1.73196C9.95966 1.72053 10.0399 1.72053 10.119 1.73196C10.2081 1.74483 10.2947 1.77732 10.468 1.84228L14.9361 3.51785C15.56 3.75178 15.8719 3.86875 16.1017 4.07133C16.3048 4.25029 16.4612 4.47601 16.5575 4.72898C16.6665 5.01533 16.6665 5.34846 16.6665 6.01472V10.0001Z",
    stroke: fill,
    strokeWidth: "1.68991",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

exports["default"] = _default;